export default "__VITE_ASSET__CSTQHVMZ__"